export const ProgressActionTypes = {
    GET_PROGRESS: '[Progress] GET_PROGRESS',
    SET_PROGRESS: '[Progress] SET_PROGRESS'
};
